import api from '@/apis'
import { mockDelay } from '@/apis/mockDelay'
import { IS_MOCK } from '@/constants'
import type { WaitlistStatus } from '@/types/serviceArea'

import { applyMockWaitlistRequest } from './waitlistMocks'

export interface PostOpenWaitlistParams {
  /** 신청할 지역주소 (예: "청주시 상당구 하하동 33-2") */
  address: string
}

/**
 * 오픈 알림 신청.
 *
 * "오픈 요청하기" CTA 클릭 시 호출. 응답으로 갱신된 waitingCount + isCompleted=true 받음.
 * 호출 후 React Query에서 GET /service-area/waitlist 캐시 invalidate 또는 setQueryData로 즉시 반영.
 *
 * 인증: Bearer (회원만 호출 가능)
 */
export const apiPostOpenWaitlist = async ({ address }: PostOpenWaitlistParams): Promise<WaitlistStatus> => {
  if (IS_MOCK) {
    await mockDelay()
    return applyMockWaitlistRequest(address)
  }
  return await api.post<WaitlistStatus, PostOpenWaitlistParams>('/service-area/waitlist', { address })
}
